import { memo } from 'react'

import { wei } from '@kwenta/wei'
import { selectClosePositionPreview, selectEditPositionModalInfo } from 'state/futures/selectors'
import { useAppSelector } from 'state/hooks'

import FeesRow from './FeeRows'

const ClosePositionFeeInfo = memo(() => {
	const tradePreview = useAppSelector(selectClosePositionPreview)
	const { market } = useAppSelector(selectEditPositionModalInfo)

	return (
		<FeesRow
			executionFee={wei(tradePreview?.settlementFee ?? 0)}
			tradeFee={wei(tradePreview?.fee ?? 0)}
			rates={{
				maker: wei(market?.feeRates.makerFee ?? 0),
				taker: wei(market?.feeRates.takerFee ?? 0),
			}}
		/>
	)
})

export default ClosePositionFeeInfo
